import React, { useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { FluidWebModal } from './FluidWebModal';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <footer className="w-full bg-gray-900 text-white pt-[4.75rem] pb-10" data-id="element-136">
        <div className="container mx-auto px-4" data-id="element-137">
          <div className="flex flex-col md:flex-row justify-between items-start mb-16" data-id="element-138">
            <div className="mb-10 md:mb-0 max-w-sm" data-id="element-139">
              <Link to="/" className="block mb-6" data-id="element-140">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KuE4GiXagr4eVmupSGvce/fluid-form-logo.png" alt="FluidForm Logo" className="h-8 w-auto brightness-0 invert" loading="lazy" data-id="element-141" />
              </Link>
              <p className="text-gray-400 text-lg leading-relaxed mb-6" data-id="element-142">
                Build forms that think, adapt, and feel human. AI-native forms
                for the modern web.
              </p>
              <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-143">
                <span data-id="element-144">Powered by FluidWeb</span>
                <span className="w-1 h-1 bg-gray-600 rounded-full" data-id="element-145"></span>
                <button onClick={() => setIsModalOpen(true)} className="text-orange-400 hover:text-orange-300 flex items-center gap-1 transition-colors" data-id="element-146">
                  Learn more <ArrowRightIcon size={12} data-id="element-147" />
                </button>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-12" data-id="element-148">
              <div data-id="element-149">
                <h4 className="font-bold text-white mb-6" data-id="element-150">Product</h4>
                <ul className="space-y-4 text-gray-400" data-id="element-151">
                  <li data-id="element-152">
                    <a href="/#features" className="hover:text-white transition-colors" data-id="element-153">
                      Features
                    </a>
                  </li>
                  <li data-id="element-154">
                    <a href="/#interfaces" className="hover:text-white transition-colors" data-id="element-155">
                      Interfaces
                    </a>
                  </li>
                  <li data-id="element-156">
                    <a href="/#integrations" className="hover:text-white transition-colors" data-id="element-157">
                      Integrations
                    </a>
                  </li>
                  <li data-id="element-158">
                    <a href="/#pricing" className="hover:text-white transition-colors" data-id="element-159">
                      Pricing
                    </a>
                  </li>
                </ul>
              </div>
              <div data-id="element-160">
                <h4 className="font-bold text-white mb-6" data-id="element-161">Resources</h4>
                <ul className="space-y-4 text-gray-400" data-id="element-162">
                  <li data-id="element-163">
                    <a href="/#faq" className="hover:text-white transition-colors" data-id="element-164">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>
              <div data-id="element-165">
                <h4 className="font-bold text-white mb-6" data-id="element-166">Legal</h4>
                <ul className="space-y-4 text-gray-400" data-id="element-167">
                  <li data-id="element-168">
                    <Link to="/terms" className="hover:text-white transition-colors" data-id="element-169">
                      Terms of Use
                    </Link>
                  </li>
                  <li data-id="element-170">
                    <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-171">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-172">
            <p className="text-gray-500 text-sm" data-id="element-173">
              © {currentYear} FluidForm, Inc. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
      <FluidWebModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-174" />
    </>;
};
export default Footer;